/**
@format
@flow
*/
export default {
  mobile: 413,
  tablet: 767,
  desktopSmall: 1023,
  desktop: 1279,
};
